<section class="wrapper background-default">
  <div class="controls" *ngIf="diagram">
    <button class="btn btn-md btn-icon white"
            tooltip="{{ 'TOOLTIPS.download' | translate }}"
            placement="bottom"
            (click)="takeScreenshot()">
      <i aria-hidden="true" class="fa fa-light fa-download"></i>
    </button>
    <button class="btn btn-md btn-icon white"
            tooltip="{{ 'TOOLTIPS.focus_node' | translate }}"
            placement="bottom"
            (click)="focusOnOrgNode()">
      <i class="fa-light fa-location-crosshairs" aria-hidden="true"></i>
    </button>
    <button class="btn btn-md btn-icon white"
            tooltip="{{ 'TOOLTIPS.zoom_to_fit' | translate }}"
            placement="bottom"
            (click)="diagram.zoomToFit()">
      <i aria-hidden="true" class="fa fa-light fa-expand-arrows-alt pointer"></i>
    </button>
    <button class="btn btn-md btn-icon white"
            tooltip="{{ 'TOOLTIPS.zoom_in' | translate }}"
            placement="bottom"
            (click)="diagram.commandHandler.increaseZoom()">
      <i aria-hidden="true" class="fa fa-light fa-search-plus pointer"></i>
    </button>
    <button class="btn btn-md btn-icon white"
            tooltip="{{ 'TOOLTIPS.zoom_out' | translate }}"
            placement="left"
            (click)="diagram.commandHandler.decreaseZoom()">
      <i aria-hidden="true" class="fa fa-light fa-search-minus pointer"></i>
    </button>
  </div>
  <div style="width: 15rem" class="left-controls" *ngIf="diagram && isDated">
    <datepicker-input name="date"
                      [(ngModel)]="date"
                      (ngModelChange)="onChangeDate($event)">
    </datepicker-input>
  </div>
  <div #chartContainer class="chart-container" [style.height]="diagramHeight"></div>

  <span class="dropdown pos-abt"
        [style.top]="dropdownMenu.top"
        [style.left]="dropdownMenu.left"
        [class.open]="dropdownMenu.opened"
        (click-outside)="dropdownMenu.opened = false">
      <ul class="dropdown-menu" (click)="dropdownMenu.opened = false" #dropdown>
        <ng-container *ngIf="selectedLeaf?.position">
          <li class="dropdown-item dropdown-additional">
            ID: {{selectedLeaf?.id}}
          </li>
          <ng-container *ngIf="selectedTree?.name === 'HierarchicalOrganization'">
            <li gp-roles
                [userRoles]="['ADMIN','DEBUG_FLATTEN']"
                (click)="openDebugFlatten()"
                class="dropdown-item pointer"
                test-id="openFlatten">
          <i aria-hidden="true" class="fa fa-light fa-folder-open dropdown-icon"></i>
          <span>{{ 'ORGANIZATION.open_flatten' | translate }}</span>
        </li>
            <li *ngIf="!isReadOnly && !selectedLeaf?.readOnly" class="dropdown-item pointer"
                (click)="this.editEntity()"
                test-id="editParameters">
              <i aria-hidden="true" class="fa fa-light fa-cog dropdown-icon"></i>
              <span>{{ 'ORGANIZATION.settings' | translate }}</span>
            </li>
            <li class="dropdown-item pointer"
                (click)="this.manageOrg()"
                test-id="modifyNode">
              <i aria-hidden="true" class="fa fa-light fa-file-alt dropdown-icon"></i>
              <span>{{ 'ORGANIZATION.edit' | translate }}</span>
            </li>
            <ng-container *ngIf="availableLevels().length || !selectedTree.supportLevel">
              <li class="dropdown-item dropdown-submenu pointer" *ngIf="availableLevels().length > 1">
                <i class="fa fa-light fa-caret-right dropdown-icon"></i>
                <a>{{ 'ORGANIZATION.create_child' | translate }}</a>
                <ul class="dropdown-menu">
                  <li *ngFor="let entityType of availableLevels()"
                      (click)="addEntity()"
                      class="pointer">
                    <a>{{ entityType }}</a>
                  </li>
                </ul>
              </li>
              <li class="dropdown-item pointer"
                  *ngIf="availableLevels().length === 1"
                  (click)="addEntity()"
                  test-id="createChild">
                <i class="fa fa-light fa-plus-circle dropdown-icon"></i>
                <span>{{ 'ORGANIZATION.create_child' | translate }}</span>
              </li>
              <li class="dropdown-item pointer"
                  *ngIf="!selectedLeaf?.readOnly"
                  (click)="addCopyEntity()"
                  test-id="createChildAsCopy">
                <i class="fa fa-light fa-copy dropdown-icon"></i>
                <span>{{ 'ORGANIZATION.create_child_as_copy' | translate }}</span>
              </li>
            </ng-container>
          </ng-container>
          <li gp-roles
              [userRoles]="['COMPANY_DELETE']"
              *ngIf="!selectedLeaf?.readOnly"
              class="dropdown-item pointer text-danger"
              (click)="deleteEntity()"
              test-id="deleteNode">
            <i aria-hidden="true" class="fa fa-light fa-trash-alt dropdown-icon"></i>
            <span>{{ 'FORMS.delete' | translate }}</span>
          </li>
        </ng-container>

        <ng-container *ngIf="dropDownMenu?.length">
  <hr class="no-margin" *ngIf="selectedLeaf?.position && selectedTree?.name === 'HierarchicalOrganization'">
  <ng-container *ngFor="let item of dropDownMenu">
    <li *ngIf="item" class="dropdown-item pointer"
        (click)="item.callback(item, selectedLeaf, dropdown)">
        <i *ngIf="item.name === 'EMPLOYEE_TREE.view_employee_file'"
           aria-hidden="true" class="fa fa-light fa-eye dropdown-icon"
           [attr.test-id]="'viewEmployeeFile'"></i>
        <i *ngIf="item.name === 'EMPLOYEE_TREE.set_backup'"
           aria-hidden="true" class="fa fa-light fa-users-gear dropdown-icon"
           [attr.test-id]="'manageBackup'"></i>
        <i *ngIf="item.name === 'EMPLOYEE_TREE.delete_backup'"
           aria-hidden="true" class="fa fa-light fa-users-slash dropdown-icon"
           [attr.test-id]="'activateBackup'"></i>
      {{ item.name | translate }}
    </li>
  </ng-container>
</ng-container>
      </ul>
  </span>
</section>
